import React, { FC } from 'react';
import { SearchMain } from './SearchMain';
import { CustomToastContainer } from '../../../components/toaster/CustomToastContainer';
import { SearchReplay } from '../search-replay/SearchReplay';

export const SearchApp: FC = () => (
  <>
    <SearchMain />
    <SearchReplay />
    <CustomToastContainer />
  </>
);
